import script from "./videoOne.vue?vue&type=script&setup=true&lang=js"
export * from "./videoOne.vue?vue&type=script&setup=true&lang=js"

import "./videoOne.vue?vue&type=style&index=0&id=be5a03d0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be5a03d0"]])

export default __exports__